import React from 'react';
import TriggerRetsUpdatePageContent from './TriggerRetsListingUpdatePageContent';
import { TriggerRetsListingUpdatePageProvider } from './TriggerRetsListingUpdatePageContext';

const TriggerRetsListingUpdatePage: React.FC = () => (
    <TriggerRetsListingUpdatePageProvider>
      <TriggerRetsUpdatePageContent />
    </TriggerRetsListingUpdatePageProvider>
  );

export default TriggerRetsListingUpdatePage;
